import { useState } from 'react'
import { CalendarDays, Download, X } from 'lucide-react'

export default function ExportDateFilterModal({
  fieldLabel = 'Período de Exportação',
  isSubmitting = false,
  onApply,
  onClose,
  submitLabel = 'Exportar',
  title = 'Exportar por Período',
}) {
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  function handleSubmit(event) {
    event.preventDefault()
    console.log('DEBUG: Submitting export filter with dates:', { start_date: startDate, end_date: endDate })
    onApply({ start_date: startDate, end_date: endDate })
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-[#1A1A1A]/35 p-3 backdrop-blur-[5px] sm:items-center sm:p-4"
      role="presentation"
      onMouseDown={onClose}
    >
      <section
        className="filter-modal my-3 max-h-[calc(100dvh-1.5rem)] w-full max-w-[500px] overflow-y-auto rounded-xl bg-white shadow-[0_22px_55px_rgba(17,24,39,0.22)] sm:my-6 sm:max-h-[calc(100dvh-3rem)]"
        role="dialog"
        aria-modal="true"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="flex min-h-[64px] items-center justify-between gap-3 border-b border-[#E5DED3] px-4 sm:min-h-[76px] sm:px-8">
          <div className="flex min-w-0 items-center gap-3 sm:gap-4">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#F3E8CE] text-[#8A6819] sm:h-10 sm:w-10">
              <Download size={18} strokeWidth={2.4} aria-hidden="true" />
            </div>
            <h2 className="min-w-0 text-base font-semibold leading-tight tracking-normal text-[#1A1A1A] sm:text-xl">
              {title}
            </h2>
          </div>
          <button
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-[#1A1A1A] transition hover:bg-[#FBF8F4] sm:h-10 sm:w-10"
            type="button"
            aria-label="Fechar filtros"
            onClick={onClose}
          >
            <X size={16} strokeWidth={2.1} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 px-4 py-5 sm:gap-5 sm:px-8 sm:py-6">
            <div className="grid gap-2">
              <label className="text-sm font-semibold text-[#1A1A1A]">
                {fieldLabel}
              </label>
              <div className="grid items-center gap-3 md:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
                <DateFilterInput
                  value={startDate}
                  onChange={setStartDate}
                  placeholder="Data inicial"
                />
                <span className="text-center text-sm font-semibold text-[#5A5147] md:block hidden">até</span>
                <DateFilterInput
                  value={endDate}
                  onChange={setEndDate}
                  placeholder="Data final"
                />
              </div>
            </div>
          </div>

          <div className="flex min-h-[76px] flex-col-reverse items-stretch justify-end gap-3 border-t border-[#E5DED3] bg-[#FBFAF8] px-4 py-4 sm:flex-row sm:items-center sm:px-8 sm:py-0">
            <button
              className="flex h-10 items-center justify-center gap-2 rounded-full border border-[#D6CDBF] bg-white px-5 text-sm font-bold tracking-[0.02em] text-[#5A5147] transition hover:bg-[#FBF8F4]"
              type="button"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              className="flex h-10 items-center justify-center gap-2 rounded-full bg-[#1A1A1A] px-5 text-sm font-bold tracking-[0.02em] text-white shadow-sm transition hover:bg-[#2C2A28]"
              disabled={isSubmitting}
              type="submit"
            >
              <Download size={17} strokeWidth={2.4} aria-hidden="true" />
              {isSubmitting ? 'Exportando...' : submitLabel}
            </button>
          </div>
        </form>
      </section>
    </div>
  )
}

function DateFilterInput({ value, onChange, placeholder }) {
  return (
    <div className="modal-date-field relative">
      <CalendarDays
        className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[#3D3329]"
        size={19}
        strokeWidth={2.2}
        aria-hidden="true"
      />
      <input
        className="modal-input modal-input-with-icon"
        placeholder={placeholder || 'dd/mm/aaaa'}
        type="date"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
